// extracted by mini-css-extract-plugin
export default {"root":"Collapsable_root__3X+j1","container":"Collapsable_container__B-YRc","opened":"Collapsable_opened__4Ke5K"};